import * as ReactDOM from 'react-dom/client'
import { PlatformSwitcher } from './utils'

const root = ReactDOM.createRoot(document.getElementById('root') as any)
root.render(<PlatformSwitcher />)
